import { type ComponentPropsWithoutRef, useEffect,useRef } from "react";

export const SmallCanvas = ({
  surrounding,
  ...props
}: {
  surrounding: string[][] | undefined;
} & ComponentPropsWithoutRef<"canvas">) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (!canvasRef.current) {
      console.warn("[SmallCanvas] canvasRef unavailable");
      return;
    }

    const ctx = canvasRef.current.getContext("2d");
    if (!ctx) {
      console.warn("[SmallCanvas] canvas context unavailable");
      return;
    }

    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvasRef.current.width, canvasRef.current.height);

    ctx.fillStyle = "rgba(0,0,0,0.2)";
    ctx.fillRect(0, 0, canvasRef.current.width, canvasRef.current.height);

    if (surrounding) {
      const PIXEL_WIDTH = canvasRef.current.width / surrounding[0].length;
      const middle: [x: number, y: number] = [
        Math.floor(surrounding[0].length / 2),
        Math.floor(surrounding.length / 2),
      ];

      for (let y = 0; y < surrounding.length; y++) {
        for (let x = 0; x < surrounding[y].length; x++) {
          const color = surrounding[y][x];
          ctx.beginPath();
          ctx.rect(x * PIXEL_WIDTH, y * PIXEL_WIDTH, PIXEL_WIDTH, PIXEL_WIDTH);

          ctx.fillStyle = color;
          ctx.fill();
        }
      }

      ctx.beginPath();
      ctx.rect(
        middle[0] * PIXEL_WIDTH,
        middle[1] * PIXEL_WIDTH,
        PIXEL_WIDTH,
        PIXEL_WIDTH,
      );
      ctx.strokeStyle = "#f00";
      ctx.lineWidth = 4;
      ctx.stroke();
    }
  }, [surrounding]);

  return <canvas width={300} height={300} ref={canvasRef} {...props} />;
};
